import React from "react";
import styles from "./ToggleSwitch.module.scss";

interface ToggleSwitchProps {
  isOn: boolean;
  onToggle: () => void;
}

/**
 * A functional React component that renders a toggle switch UI element.
 */
export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ isOn, onToggle }) => (
    <div
        className={styles.toggleContainer}
        onClick={onToggle}
        onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
                onToggle();
            }
        }}
        role="switch"
        aria-checked={isOn}
        tabIndex={0}
    >
        <svg
            className={styles.toggleTrack}
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="24"
            viewBox="0 0 40 24"
            fill="none"
        >
            <rect
                x={isOn ? 0.644531 : 0.176758}
                y="0.715088"
                width="40"
                height="22.2222"
                rx="11.1111"
                fill={isOn ? "#1D2D5A" : "#9EA1A8"}
            />
            <circle cx={isOn ? 29.5336 : 11.2875} cy="11.8258" r="8.88906" fill="#D9D9D9" />
            <circle cx={isOn ? 6.6441 : 6.17632} cy="20.7151" r="0.222222" fill="#1D2D5A" />
        </svg>
    </div>
);
